import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getAccountConference} from 'src/openapi/admin/apis/ConferenceApi';
import {useAppDispatch} from 'src/store/hooks';

import type {SuccessPayload} from 'src/typedef';

type Props = {
    accountId: number,
};

export const useGetConferenceId = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(async (signal: AbortSignal) => {
        const response = await apiDispatch(getAccountConference({accountId}, {signal}));
        if (response.payload.success) {
            const payload: SuccessPayload<number> = {
                success: true,
                error: false,
                data: response.payload.data.id,
            };
            return Promise.resolve({type: '', payload});
        } else {
            return Promise.resolve({type: '', payload: response.payload});
        }
    }, [accountId, apiDispatch]);

    return useReadOnlyDataHook({
        initValue: null,
        getDispatchAction,
    });
};
